import { render, staticRenderFns } from "./RoundTripPlaceInput.vue?vue&type=template&id=2db2178f&scoped=true&"
import script from "./RoundTripPlaceInput.vue?vue&type=script&lang=js&"
export * from "./RoundTripPlaceInput.vue?vue&type=script&lang=js&"
import style0 from "./RoundTripPlaceInput.vue?vue&type=style&index=0&id=2db2178f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2178f",
  null
  
)

export default component.exports